import { RawAxiosRequestHeaders } from "axios";
import { v4 as uuidv4 } from "uuid";

export const constructRequestHeaders = (
  token: string | undefined,
  contentType?: string
): RawAxiosRequestHeaders => {
  // Used by network.ts

  const headers: RawAxiosRequestHeaders = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Method": "POST, GET, OPTIONS, DELETE",
    "Content-Type": contentType || "application/json",
    "Access-Control-Allow-Headers": "Content-Type",
  };

  if (token && token !== "" && token !== null) {
    headers.Authorization = `Bearer ${token}`;
  }

  headers["x-request-id"] = uuidv4();

  return headers;
};
